import React, { PropsWithChildren } from "react";
import styles from "./style.module.scss";
import classNames from "classnames";

interface CardProps extends PropsWithChildren {
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className }) => {
  return <section className={classNames(styles.container, className) }>{children}</section>;
};

export default Card;
